import { format, Icon } from "@fluentui/react";
import * as React from "react";
// Styles
import { getClassNames, getStyles } from "./CollapsibleSection.styles";
/** A collapsible section for the task details pane */ export function CollapsibleSection(props) {
    const classNames = getClassNames(getStyles(props.styles));
    const [isVisible, setVisible] = React.useState(true);
    const headingId = React.useId();
    const toggle = ()=>{
        const newState = !isVisible;
        setVisible(newState);
    };
    const hideLabel = props.collapsibleSectionHideAriaLabel;
    const showLabel = props.collapsibleSectionShowAriaLabel;
    const ariaLabel = format(isVisible ? hideLabel : showLabel, props.label);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.root,
        role: "group",
        "aria-labelledby": headingId
    }, /*#__PURE__*/ React.createElement("span", {
        id: headingId,
        role: "heading",
        "aria-level": 2
    }, /*#__PURE__*/ React.createElement("button", {
        className: classNames.expandSectionButton,
        onClick: toggle,
        "aria-label": ariaLabel,
        "aria-expanded": isVisible
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: isVisible ? "ChevronDown" : "ChevronUp"
    }), props.label)), isVisible && props.children);
}
